const PRODUCT_PREFIX = 'lsr';

export const getMerchantDetails = () => {
  const session = window.merchantos.session;

  const accountId = session.getSystemCustomerID() ?? 'Unknown Account ID';
  const merchantName = session.getSystemCustomerName() ?? 'Unknown Merchant';
  const userId = session.getSystemUserID() ?? 'Unknown User ID';
  const shopId = session.getShop()?.shopID ?? 'Unknown Shop ID';
  const roleName = session.getEmployee()?.role ?? 'Unknown Role ID';

  const pui = `${PRODUCT_PREFIX}:${userId}`;
  const pli = `${PRODUCT_PREFIX}:${accountId}-${shopId}`;

  return {
    accountId,
    merchantName,
    userId,
    shopId,
    pli,
    pui,
    roleName,
  };
};
